import { z } from 'zod';
/**
 * « Mot de passe oublié » (D3) : la personne donne **son identifiant**, pas une adresse — c'est ce
 * qu'elle tape tous les jours, et l'adresse n'est pas unique en base (M6). La réponse est la même
 * que le compte existe ou non.
 */
export const passwordResetRequestSchema = z.object({ login: z.string().trim().min(1) });
/** Le jeton du lien reçu par e-mail : il tire un nouveau mot de passe, une seule fois (D3). */
export const passwordResetConfirmSchema = z.object({ token: z.string().min(1) });
/**
 * Ce que l'écran anonyme « Mot de passe oublié » a besoin de savoir avant d'afficher son
 * formulaire : si un administrateur a coupé l'envoi par e-mail (`passwordResetByEmail`).
 */
export const passwordResetAvailabilitySchema = z.object({ enabled: z.boolean() });
//# sourceMappingURL=password-reset.js.map